import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AuthState } from "../../features/auth/services/auth.state";
import { TenantUrlUtilService } from "@shared/services/tenant-url-util.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authState = inject(AuthState);
  const tenantUrlUtil = inject(TenantUrlUtilService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authState.clearAuthData();
        if (!router.url.startsWith("/login")) {
          const loginUrl = tenantUrlUtil.buildLoginUrl();
          router.navigateByUrl(loginUrl, { replaceUrl: true });
        }
      }
      return throwError(() => error);
    }),
  );
};
